import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoginInterface } from '../../interfaces/login.interface';
import { Global } from '../global';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private API_URL: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly router: Router
  ) {
    this.API_URL = Global.url + '/auth'
  }
  // Método para autenticar y guardar el token
  login(credentials: LoginInterface): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/token`, credentials)
      .pipe(
        tap(response => {
          localStorage.setItem('userName', response.user_name);
          localStorage.setItem('authToken', response.token);
        })
      );
  }
  getIPAddress(): Observable<any> {
    return this.httpClient.get('https://geolocation-db.com/json/');
  }

  setCookie(access_token: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(`${this.API_URL}/set_cookie`, { access_token }, { headers: headers, withCredentials: true });
  }

  verifyToken(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const token = localStorage.getItem('authToken');
    // Agrega el token en el encabezado Authorization si existe
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.post<any>(`${this.API_URL}/verify_token`, {}, { headers: headers, withCredentials: true })
  }

  getTokenZohoCrm(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(`${this.API_URL}/token_crm`, {}, { headers: headers, withCredentials: true })
  }

  saveRoleRequest(email: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(`${this.API_URL}/request_role`, { email }, { headers: headers, withCredentials: true })
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('authToken');
    return !!token; // Devuelve true si el token existe, false en caso contrario
  }

  logout(): Observable<any> {
    localStorage.clear(); // Limpia todo el localStorage
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(`${this.API_URL}/log_out`, {}, { headers: headers, withCredentials: true })
  }

  typeUser() {
    return localStorage.getItem('user_role');
  }

}